import { TakeVideoHookPropsType } from '@/common/components/camera/types/hooksTypes';

const useTakeVideo = ({ stream }: TakeVideoHookPropsType) => {
  const handleMediaRecorder = (videoBitsPerSecond: number) => {
    const preferredMimeTypes = [
      'video/webm;codecs=vp9',
      'video/webm;codecs=vp8',
      'video/mp4;codecs=avc1',
      'video/webm',
      'video/mp4',
    ];

    let supportedMimeType;
    for (const mimeType of preferredMimeTypes) {
      if (MediaRecorder.isTypeSupported(mimeType)) {
        supportedMimeType = mimeType;
        break;
      }
    }
    const streamObject = stream;

    if (!streamObject) {
      return null;
    }
    return new MediaRecorder(streamObject, {
      mimeType: supportedMimeType,
      videoBitsPerSecond,
    });
  };
  const handleCreateData = ({ blob }: { blob: Blob }) => {
    const url = URL.createObjectURL(blob);
    return { blob, url };
  };

  const takeVideo = (quality: number = 10000) => {
    const myMediaRecorder = handleMediaRecorder(quality)!;

    const chunks: Blob[] = [];

    const startVideo = () => {
      myMediaRecorder.start();
    };

    myMediaRecorder.ondataavailable = (e) => {
      chunks.push(e.data);
    };

    const stopVideo = (): Promise<ReturnType<typeof handleCreateData>> =>
      new Promise((resolve) => {
        myMediaRecorder.onstop = () => {
          const blob = new Blob(chunks, {
            type: 'video/mp4',
          });
          resolve(handleCreateData({ blob }));
        };
        myMediaRecorder.stop();
      });

    return {
      startVideo,
      stopVideo,
    };
  };
  return { takeVideo };
};

export default useTakeVideo;
